export default "__VITE_ASSET__CY73UB$B__"